export enum PermissionType {
  USER = "USER",
  ADMIN = "ADMIN",
}
